import { apiRequestDev } from './apiRequest';

export const getAllFeedback = async (config, userId) => apiRequestDev(config, `/feedback/all/${userId}`);

export const getFeedback = async (config, userId, feedbackId) =>
  apiRequestDev(config, `/feedback/${userId}/${feedbackId}`);

export const getCouncillorFeedback = async (config, userId) =>
  apiRequestDev(config, `/feedback/all/councillor/${userId}`);

export const getPendingFeedback = async (config, userId) => apiRequestDev(config, `/feedback/pending/${userId}`);

export const getFeedbackByConstituentId = async (config, userId, constituentId) =>
  apiRequestDev(config, `/feedback/${userId}/constituent/${constituentId}`);

export const createFeedback = async (
  config,
  stafferId,
  constituentId,
  name,
  phone,
  email,
  address,
  postalCode,
  type,
  subtype,
  importance,
  description,
  memberNotes,
  source,
  sentiment = null,
  dateUtc = null,
  pendingFeedbackId = null,
  emailId = null,
) => {
  return apiRequestDev(config, '/feedback/create', 'post', {
    staffer_id: stafferId,
    constituent_id: constituentId,
    name,
    phone,
    email,
    address,
    postal_code: postalCode,
    type,
    subtype,
    importance,
    sentiment,
    description,
    member_notes: memberNotes,
    source,
    date_utc: dateUtc,
    pending_feedback_id: pendingFeedbackId,
    email_id: emailId,
  });
};

export const saveFeedback = async (
  config,
  feedbackId,
  userId,
  constituentId,
  name,
  phone,
  email,
  address,
  postalCode,
  type,
  subtype,
  importance,
  description,
  memberNotes,
  source,
) => {
  return apiRequestDev(config, `/feedback/${feedbackId}/update`, 'patch', {
    user_id: userId,
    constituent_id: constituentId,
    name,
    phone,
    email,
    address,
    postal_code: postalCode,
    type,
    subtype,
    importance,
    description,
    member_notes: memberNotes,
    source,
  });
};

export const setFeedbackStatus = async (config, userId, ids, status) => {
  return apiRequestDev(config, '/feedback/mark', 'patch', {
    user_id: userId,
    ids,
    status,
  });
};

export const sendResponse = async (config, userId, caseId, email, response) => {
  return apiRequestDev(config, '/feedback/response', 'post', {
    user_id: userId,
    case_id: caseId,
    constituent_email: email,
    response,
  });
};

export const deleteFeedback = async (config, feedbackId, userId) =>
  apiRequestDev(config, `/feedback/${feedbackId}/delete?user_id=${userId}`, 'delete');

export const deletePendingFeedback = async (config, feedbackId, userId) =>
  apiRequestDev(config, `/feedback/${feedbackId}/delete_pending?user_id=${userId}`, 'delete');
